import { createStyles, Divider, Grid, makeStyles, MenuItem, MenuList, Theme, Typography } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HelpIcon from '@material-ui/icons/Help';
import PeopleIcon from '@material-ui/icons/People';
import PersonIcon from '@material-ui/icons/Person';
import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { selectViewerUser } from '../features/app/AppSlice';
import { authProvider } from '../util/AuthProvider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      //padding: theme.spacing(2),
      textAlign: 'start',
    },
    userInfo: {
      padding: theme.spacing(3),
    },
    menuItem: {
      height: 55,
      textDecoration: 'none',
      color: theme.palette.text.primary,
    },
    menuItemIcon: {
      marginRight: theme.spacing(2),
      color: theme.palette.grey[700],
    },
  }),
);

interface SettingsMenuProps {
  isOnboarded: boolean;
  afterClick: () => void;
}

const SettingsMenu: React.FC<SettingsMenuProps> = props => {
  const { isOnboarded, afterClick } = props;
  const classes = useStyles();
  const viewerUser = useSelector(selectViewerUser);

  const handleLogout = () => {
    authProvider.logout();
    afterClick();
  };

  return (
    <Grid container className={classes.root}>
      <Grid className={classes.userInfo} item container xs={12}>
        <Grid item xs={9}>
          <Typography variant="h6">
            {viewerUser?.firstName} {viewerUser?.lastName}
          </Typography>
          <Typography variant="subtitle1">{viewerUser?.email}</Typography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MenuList data-cy="settings-menu">
          {isOnboarded && (
            <MenuItem component={NavLink} onClick={afterClick} className={classes.menuItem} to="/settings" data-cy="manage-account">
              <PersonIcon className={classes.menuItemIcon} />
              Manage account
            </MenuItem>
          )}
          {isOnboarded && (
            <MenuItem
              component={NavLink}
              onClick={afterClick}
              className={classes.menuItem}
              to="/user-management"
              data-cy="manage-users"
            >
              <PeopleIcon className={classes.menuItemIcon} />
              Manage users
            </MenuItem>
          )}
          <MenuItem component={NavLink} className={classes.menuItem} onClick={afterClick} to="/help" data-cy="help">
            <HelpIcon className={classes.menuItemIcon} />
            Help
          </MenuItem>
          <MenuItem className={classes.menuItem} onClick={handleLogout} data-cy="sign-out">
            <ExitToAppIcon className={classes.menuItemIcon} />
            Sign out
          </MenuItem>
        </MenuList>
      </Grid>
    </Grid>
  );
};

export default SettingsMenu;
